import { z } from 'zod';

// =============================================================================
// CANONICAL SCHEMA
// =============================================================================

export const SceneSchema = z.object({
  id: z.string().describe('Unique identifier for the scene'),
  chapterId: z.string().describe('ID of the chapter this scene belongs to'),
  sceneNumber: z.number().optional().describe('The chronological order of the scene within the chapter.'),
  title: z.string().describe('The title of the scene'),
  keyBeats: z.string().optional().describe('The key story beats and moments that occur in this scene'),
  projectedWordCount: z.number().optional().describe('Planned word count for this scene'),
  characterIds: z.array(z.string()).optional().describe('IDs of characters that appear in this scene'),
});

// =============================================================================
// SUBSET SCHEMAS
// =============================================================================

export const SceneRefSchema = z.object({
  id: z.string().describe('Unique identifier for the scene'),
  title: z.string().describe('The title of the scene'),
});

export const SceneContextSchema = z.object({
  id: z.string().describe('Unique identifier for the scene'),
  title: z.string().describe('The title of the scene'),
  keyBeats: z.string().optional().describe('The key story beats and moments that occur in this scene'),
});

// Type inference
export type Scene = z.infer<typeof SceneSchema>;
export type SceneRef = z.infer<typeof SceneRefSchema>;
export type SceneContext = z.infer<typeof SceneContextSchema>;
